// Lista canônica — espelha o enum PaymentMethod do Prisma (schema.prisma).
// A ordem é a ordem de exibição dos dropdowns "completos" do financeiro.
export const PAYMENT_METHODS = [
    'cash',
    'pix',
    'credit_card',
    'debit_card',
    'transfer',
    'boleto',
    'other',
];
// Labels canônicos (pt-BR) — antes viviam em apps/web/src/services/cash-flow.ts.
export const PAYMENT_METHOD_LABELS = {
    cash: 'Dinheiro',
    pix: 'PIX',
    credit_card: 'Cartão de Crédito',
    debit_card: 'Cartão de Débito',
    transfer: 'Transferência',
    boleto: 'Boleto',
    other: 'Outro',
};
// Labels curtos pros seletores compactos (chips do finalizar atendimento).
export const PAYMENT_METHOD_SHORT_LABELS = {
    ...PAYMENT_METHOD_LABELS,
    credit_card: 'Crédito',
    debit_card: 'Débito',
};
// Subconjunto NOMEADO: finalizar atendimento (ADR-0001 — subset PROPOSITAL) =
// canônica menos boleto/other. Cobrança presencial não emite boleto e "outro"
// não é rastreável pra comissão/conciliação. Espelha o enum
// AppointmentPaymentMethod do backend (complete-with-payment.dto.ts).
// Ordem pix-first: espelho do uso real da recepção no fluxo rápido.
export const APPOINTMENT_PAYMENT_METHODS = [
    'pix',
    'cash',
    'credit_card',
    'debit_card',
    'transfer',
];
// Subconjunto NOMEADO: cobrança presencial avulsa (pendências do caixa e venda
// de pacote à vista) = canônica menos boleto/other, pela mesma razão acima.
// Ordem cash-first (comportamento vigente preservado — ver ADR-0001).
export const IN_PERSON_PAYMENT_METHODS = [
    'cash',
    'pix',
    'credit_card',
    'debit_card',
    'transfer',
];
// Subconjunto NOMEADO: tela de config de TAXAS (Story 44.6/ACR-019) = canônica
// completa, ordem cartões-primeiro — débito/crédito são quem tem taxa de
// maquininha; o resto vem depois pra promo/exceção (pix com taxa etc.).
export const FEE_CONFIG_PAYMENT_METHODS = [
    'debit_card',
    'credit_card',
    'pix',
    'cash',
    'transfer',
    'boleto',
    'other',
];
// Subconjunto NOMEADO: formas que aceitam REGRA DE TAXA (Story 65.48) = as da tela de taxas
// menos o dinheiro, que nunca tem taxa. Máquina, preferência de parcelamento e plano seguem
// com FEE_CONFIG_PAYMENT_METHODS: lá o dinheiro é só uma forma, não uma taxa.
export const FEE_RULE_PAYMENT_METHODS = [
    'debit_card',
    'credit_card',
    'pix',
    'transfer',
    'boleto',
    'other',
];
/** `true` quando a forma aceita regra de taxa. Dinheiro nunca aceita. */
export const acceptsFeeRule = (method) => !!method && FEE_RULE_PAYMENT_METHODS.includes(method);
// Subconjunto NOMEADO: formas de cartão (Story 65.18/65.19). Só elas levam bandeira no
// recebimento em partes; parcelas valem só para o crédito.
export const CARD_PAYMENT_METHODS = [
    'credit_card',
    'debit_card',
];
/** `true` quando a forma é cartão (crédito ou débito). */
export const isCardPaymentMethod = (method) => !!method && CARD_PAYMENT_METHODS.includes(method);
//# sourceMappingURL=payment-methods.js.map